<div class="content">
  <div class="content-row">
    <div class="container clear">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
